<!--  -->
<template>
  <div>
    <div
      class="mask"
      :style="{
        width: `calc(100vw - ${scrollWidth}px)`,
        marginLeft: scrollWidth + 'px'
      }"
      v-show="loading"
    >
      <div class="main">
        <a-spin tip="努力加载中..." size="large"> 
        </a-spin>
        <!-- <img
          alt=""
          src="http://hbimg.huabanimg.com/fdf3ae9d1ae39ad264c3b26f713e06a867ac1dcb1ec11-GBtZGs_fw658/format/webp"
        /> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    loading: {
      type: Boolean, //指定传入的类型
      default: false //这样可以指定默认的值
    },
    scrollWidth: {
      type: Number, //指定传入的类型
      default: 200 //这样可以指定默认的值
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
<style scoped lang="scss">
.mask {
  // width: calc(100vw - 200px);
  height: calc(100vh);
  position: fixed;
  z-index: 999999;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 1);
}
.main {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/tools/loading.vue